import styles from '../ProductSelector.module.scss';
import React from 'react';
import { Image } from '@solarwindscloud/cloud-ui';
import { sortObjectByKeysAlphabetically } from '../../../utils/utils';

export const ProductList = ({ productLinks, logos }) => {
  const sortedProductLinks = getSortedProductLinks();

  return Object.keys(sortedProductLinks).map((key, index) => (
    <a
      className={styles.link}
      href={productLinks[key]}
      key={index}
      id={'product-' + (index + 1)}
      data-test-product-link
    >
      <Image src={logos[key]} height="47" alt={`Solarwinds ${key}`} />
    </a>
  ));

  function getSortedProductLinks() {
    return sortObjectByKeysAlphabetically(productLinks);
  }
};
